export default __webpack_public_path__ + "static/media/Inter-VariableFont_opsz,wght.e05c5f3d.ttf";